const SEPARATOR = " /// ";

export default function Marquee({ items, color = "#FF5E00" }) {
  return (
    <div className="overflow-hidden border-y border-orange-500/20 bg-[#04070F] py-4" data-testid="editorial-marquee">
      <div className="animate-marquee flex w-max whitespace-nowrap">
        {[0, 1].map((copy) => (
          <span key={copy} aria-hidden={copy === 1}
            className="font-mono2 pr-2 text-sm font-bold uppercase tracking-[0.3em] text-slate-500">
            {items.map((part, i) => (
              <span key={i}>
                <span style={{ color }}>{part}</span>
                <span className="mx-4 text-slate-600">///</span>
              </span>
            ))}
          </span>
        ))}
      </div>
    </div>
  );
}
